// extracted by mini-css-extract-plugin
export var clauseRow = "_bf-6";
export var emptyState = "_bf-d";
export var filterContent = "_bf-a";
export var filterGroup = "_bf-1";
export var filterGroupContainer = "_bf-0";
export var nestedGroup = "_bf-2";
export var nestedGroupContent = "_bf-b";
export var nestedGroupDepth1 = "_bf-3";
export var nestedGroupDepth2 = "_bf-4";
export var nestedGroupDepth3 = "_bf-5";
export var nestedGroupEmpty = "_bf-c";
export var operatorAnd = "_bf-8";
export var operatorOr = "_bf-9";
export var operatorToggle = "_bf-7";
export var removeGroupButton = "_bf-e";